<div class="flex items-center">
  <img
    src="{{ userAssociation.user.avatar_url }}"
    class="w-6 h-6 m-2px rounded-full text-card shadow-solid"
    *ngFor="let userAssociation of userAssociations; let i = index"
    [ngClass]="{ '-ml-3': i > 0 }"
    [matTooltip]="userAssociation.user.full_name"
    alt="{{ userAssociation.user.full_name }}"
  />
  <button
    mat-icon-button
    [matTooltip]="'Add User'"
    class=""
    [ngClass]="{ '-ml-1': userAssociations?.length > 0 }"
    (click)="openUserAssociationsPanel()"
    #userAssociationsPanelOrigin
  >
    <mat-icon [svgIcon]="'add_circle'"></mat-icon>
  </button>
</div>
<ng-template #userAssociationsPanel>
  <div class="contacts-details-tags-panel">
    <div class="tags-panel-header">
      <div class="new-tag">
        <mat-icon [svgIcon]="'search'"></mat-icon>
        <input
          type="text"
          placeholder="Find user"
          (input)="filterUserAssociations($event)"
          (keydown)="filterUserAssociationsInputKeyDown($event)"
          [maxLength]="50"
          #newTagInput
        />
      </div>
    </div>

    <div class="available-tags">
      <ng-container>
        <mat-checkbox
          *ngFor="let userAssociation of filteredUserAssociations; trackBy: trackByFn"
          [color]="'primary'"
          [checked]="associatedUserIds.includes(userAssociation.user.id)"
          (change)="toggleUserAssociation(userAssociation, $event)"
          [disabled]="!userAssociation.user?.active"
        >
          {{ userAssociation.user.full_name }}
        </mat-checkbox>
      </ng-container>
    </div>
    <div class="create-tag" (click)="openInvitationModal()" matRipple>
      <mat-icon [svgIcon]="'add'"></mat-icon>
      <div>Invite Guest User</div>
    </div>
  </div>
</ng-template>
